import { RootState } from 'reducers';

export const getRedirectRoute = (state: RootState) =>
    state.redirectReducer.route;
export const getLogoutIsPosting = (state: RootState) =>
    state.redirectReducer.isPosting;
